






































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import SearchField from '@/components/SearchField.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import TagInput from '@/components/TagInput.vue';
import Loader from '@/components/Loader.vue';
import api, { apiSandbox } from '@/libs/api';
import numberFormat from '@/libs/numberFormat';
import Select from '@/components/Select.vue';
import FormInput from '@/components/FormInput.vue';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import Button from '@/components/Button.vue';

import { ValidationObserver } from 'vee-validate';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    StatusIndicator,
    Loader,
    SearchField,
    TagInput,
    Select,
    FormInput,
    Button,
    ValidationObserver,
  },
  methods: {
    numberFormat,
  },
})
export default class ReportDetail extends Vue {
  @Prop(String) mcode!: string;
  @Prop(String) channelID!: string;
  @Prop(String) editedChannel!: string;
  @Prop(String) channelInput!: string;
  loading = false;
  serverKey = '';
  clientKey = '';
  phase = '';
  paymentFlag = '';
  notificationEmail = '';
  moduleVersion = '';
  refundFee = '';
  TransactionFeeType = '';
  transactionFeeValue = '';

  close() {
    this.$emit('modal', false);
  }

  mounted() {
    this.mcode = this.$route.params.type;
  }

  async addChannel() {
    try {
      this.loading = true;

      await apiSandbox.post('/merchant/channel', {
        auto: 0,
        /* eslint-disable @typescript-eslint/camelcase */
        channel_id: 1080,
        service_code: 1080,
        merchant_code: this.mcode,
        trans_fee_type: this.TransactionFeeType,
        trans_fee_value: this.transactionFeeValue,
        module_version: this.moduleVersion,
        payment_url: this.paymentFlag,
        fee_settlement: 5000,
        fee_refund: this.refundFee,
        fee_bank: 5000,
        fee_sprint: 5000,
        fee_transaction: 5000,
        isEscrow: 1,
        server_key: this.serverKey,
        client_key: this.clientKey,
        email: 'bimapw4@gmail.com',
        phase: 'DEVELOPMENT',
      });
      this.close();
    } catch (err) {
      showToast(ToastType.FAILED, 'Oops… Sorry', err.response.data);
      this.loading = false;
    }
  }
}
